import React from 'react';

import { fixDecimals } from '../../../../../helpers';
import { GameStatsPropsType } from '../types';

import './GameStats.scss';

const GameStats = ({ label, statA, statB, colorA, colorB }: GameStatsPropsType) => {
  
  const maxStat = statA > statB ? statA : statB;
  
  return (
    <div className={'game-stats'}>
      <h6>{label}</h6>
      <div className="graph-l">
        <h4>{fixDecimals(statA, 1)}</h4>
        <label className="l-01" style={{ width: `${100 - ((statA / maxStat) * 100)}%`, background: '#AFBCC2' }} />
        <label className="l-01" style={{ width: `${(statA / maxStat) * 100}%`, background: colorA }} />
      </div>
      <div className="graph-r">
        <h4>{fixDecimals(statB, 1)}</h4>
        <label className="l-02" style={{ width: `${(statB / maxStat) * 100}%`, background: colorB }} />
        <label className="l-02" style={{ width: `${100 - ((statB / maxStat) * 100)}%`, background: '#AFBCC2' }} />
      </div>
    </div>
  );
};

export default GameStats;
